<div class="banner-inner">
  <ng-content></ng-content>
</div>
